import { useEffect } from "react";
import { Box, Flex, Text } from "@storyofams/react-ui";
import axios from "axios";
import Image from "next/image";
import { useQuery } from "react-query";
import { css } from "styled-components";

export const Author = ({ author }) => {
  const { data: user, refetch: refetchUser } = useQuery(
    "user",
    async () => {
      if (!author) return null;
      const { data } = await axios.get(`/api/circle/getUser?email=${author}`);
      if (data?.success === false) return null;
      return data;
    },
    { enabled: !!author }
  );
  useEffect(() => {
    refetchUser();
  }, [author]);
  if (!user) return null;
  return (
    <Flex
      width={"100%"}
      backgroundColor="#FCF9F7"
      mb={["10px", "40px"]}
      borderLeft={"8px solid #EEE3D7"}
    >
      <Flex
        width={"100%"}
        py={["15px", "32px"]}
        px={["15px", "40px"]}
        flexDirection={["column", "row"]}
      >
        <Box
          flex={"none"}
          position={"relative"}
          width={["77px", "180px"]}
          height={["77px", "180px"]}
          css={css({
            img: {
              borderRadius: "50%",
            },
          })}
        >
          {user.avatar_url && (
            <Image src={user.avatar_url} layout="fill" alt="awd" />
          )}
        </Box>
        <Box ml={[0, "48px"]}>
          <Text
            fontFamily={"DINPro"}
            fontWeight={700}
            fontSize="24px"
            lineHeight={"28.8px"}
            mb={[2, "24px"]}
          >{`${user.first_name} ${user.last_name ? user.last_name : ""}`}</Text>
          <Text color="#1D1D1BCC" fontSize={"18px"} lineHeight="25.2px">
            {user.bio}
          </Text>
        </Box>
      </Flex>
    </Flex>
  );
};
